import { useCallback } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@boundary/components/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { ServiceMetadataStore } from "@infrastructure/stores/serviceMetadata.store";
import styles from "./serviceInfoPopup.module.scss";

interface ServiceInfoPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  serviceType: string;
  title: string;
  description: string | null;
  priceLabel: string | null;
  iconUrl: string | null;
  hint: string | null;
  enabled: boolean;
  onAction: () => void;
}

export function ServiceInfoPopup({
  open,
  onOpenChange,
  serviceType,
  title,
  description,
  priceLabel,
  iconUrl,
  hint,
  enabled,
  onAction,
}: ServiceInfoPopupProps) {
  const metadata = ServiceMetadataStore.getByType(serviceType);
  const recommendations = metadata?.recommendations ?? null;

  const handleAction = useCallback(() => {
    onOpenChange(false);
    onAction();
  }, [onOpenChange, onAction]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={styles.dialogContent}>
        <VisuallyHidden.Root>
          <DialogTitle>{title}</DialogTitle>
        </VisuallyHidden.Root>

        <img
          className={styles.icon}
          src={iconUrl || "/assets/map/printerService.png"}
          alt=""
        />

        <h2 className={styles.title}>{title}</h2>

        {priceLabel && <div className={styles.pill}>{priceLabel}</div>}

        {description && (
          <p className={styles.description}>{description}</p>
        )}

        {recommendations && (
          <p className={styles.recommendations}>{recommendations}</p>
        )}

        {hint && !enabled && (
          <p className={styles.hint}>{hint}</p>
        )}

        <button
          className={styles.actionButton}
          onClick={handleAction}
          disabled={!enabled}
        >
          {enabled ? "Распечатать" : hint || "Недоступно"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
